import {appdata} from "../logic_tmp/appdata/AppData";
import i18next from "i18next";

export function getFacebookShareLink() {
    let skinKey = "default";
    if (appdata.skin !== undefined && appdata.skin !== "")
        skinKey = appdata.skin;
    // @ts-ignore
    return appdata.product["promotionLinks"]["Facebook"][skinKey][i18next.language];
}
